import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { GraduationCap } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-2 pb-12 md:pt-4 md:pb-16 overflow-hidden bg-white" data-id="element-172">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 pointer-events-none" data-id="element-173">
        <div className="absolute -top-[10%] left-1/2 -translate-x-1/2 w-[80%] h-[60%] rounded-full bg-gold/5 blur-3xl" data-id="element-174" />
      </div>

      <div className="container mx-auto px-4 relative z-10 max-w-3xl text-center" data-id="element-175">
        {/* Pill badge */}
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="inline-flex items-center gap-2 px-5 py-2 mb-8 rounded-full border border-gold/40 bg-gold/5 text-navy font-semibold text-sm tracking-wider uppercase" data-id="element-176">
          <GraduationCap className="w-4 h-4 text-gold" data-id="element-177" />
          MIS PRIMERAS LECTURAS
        </motion.div>

        {/* Two-tone headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-sans md:text-5xl font-extrabold text-navy mb-4 text-[20px]" data-id="element-178">
          La ayuda que tu hijo necesita para leer sus primeras palabras,{' '}
          <span className="text-gold" data-id="element-179">lista desde hoy.</span>
        </motion.h1>

        {/* Big centered product image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="mb-8" data-id="element-180">
          <img src="https://cdn.magicpatterns.com/uploads/1Lg8boNxXxBLRjQZaKz5Hb/ChatGPT_Image_14_jun_2026,_02_49_33.webp" alt="Mis Primeras Lecturas — Sistema Completo de lectura para niños de 4 a 7 años" width={672} height={672} loading="eager" fetchPriority="high" decoding="async" sizes="(max-width: 768px) 100vw, 672px" className="w-full h-auto max-w-2xl mx-auto rounded-2xl shadow-2xl shadow-navy/10" data-id="element-181" />
        </motion.div>

        {/* Paragraph */}
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="md:text-xl text-slate-600 mb-8 max-w-2xl mx-auto text-[16px]" data-id="element-182">
          Para padres de niños de 4 a 7 años que reconocen letras pero todavía
          no logran leer palabras completas.
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-183">
          <Button variant="gold" size="lg" href="#pricing" className="w-full sm:w-auto shadow-xl shadow-gold/20 text-base tracking-wide" data-id="element-184">
            QUIERO ACCEDER AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}